import Indicator from "./Indicator";
import styled from "styled-components";
import {useContext, useEffect, useState} from "react";
import {ShowLoginContext} from "../../contexts/ShowLoginContext";
import {useMessages} from "../../hooks/useMessages";
import Login from "../auth/Login";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Register from "../auth/Register";
import {getTheme} from "../../shared/themeUtils";
import {useRouter} from "next/router";

const Contain = styled.div`
  text-align: center;
  padding: ${getTheme("space.2")};
  
  .box-tabs {
    margin-bottom: ${getTheme("space.4")};
  }
`

type RegisterType = "private" | "company"

const IndicatorLogin = () => {
  const {showLoginContext, setShowLoginContext} = useContext(ShowLoginContext);
  const [activeTab, setActiveTab] = useState("login")
  const [registrationType, setRegistrationType] = useState<RegisterType>("private")
  const messagesQuery = useMessages()
  const router = useRouter()

  useEffect(() => {
    if (router.isReady) {
      // Show private registration
      if (router.query.showPrivateRegistration) {
        setShowLoginContext(true)
        setActiveTab("register")
      }

      // Show company registration
      if (router.query.showCompanyRegistration) {
        setShowLoginContext(true)
        setActiveTab("register")
        setRegistrationType("company")
      }
    }
  }, [router])


  const content = (
    <Contain>
      <Tabs
        id="auth-option"
        activeKey={activeTab}
        onSelect={k => k != null ? setActiveTab(k) : null}
        unmountOnExit={true}
        className="box-tabs">

        {messagesQuery.data &&
          <Tab eventKey="login" title={messagesQuery.data.messages["login"]}>
            <Login />
          </Tab>}

        {messagesQuery.data &&
          <Tab eventKey="register" title={messagesQuery.data?.messages["register"]}>
            <Register registerType={registrationType}/>
          </Tab>}
      </Tabs>
    </Contain>
  )

  return (
    <Indicator placement={"end"} content={content} iconVariant={"medium"} icon="user-line"
               text={messagesQuery.data?.messages["login"]} showLogin={showLoginContext}/>
  )
}

export default IndicatorLogin;
